export default __webpack_public_path__ + "static/nathaniel-a2332c652c3e5e9d737a837e7ee9fcb8.png";